import { render, staticRenderFns } from "./QrAsset.vue?vue&type=template&id=2a2fafc8&scoped=true"
import script from "./QrAsset.vue?vue&type=script&lang=js"
export * from "./QrAsset.vue?vue&type=script&lang=js"
import style0 from "./QrAsset.vue?vue&type=style&index=0&id=2a2fafc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2fafc8",
  null
  
)

export default component.exports